import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    dTransferCashDesksClearFiltersAC,
    dTransferCashDesksSetDataSagaAC,
    dTransferCashDesksSetFiltersAC, dTransferCashDesksSetItemsForPageAC, dTransferCashDesksSetPageNumberAC
} from 'model/dashboardTransferCashDesks/dTransferCashDesksActionCreators';
import {
    IdTransferCashDesksState,
    typeTransferCashDesksFilters
} from 'model/dashboardTransferCashDesks/dTransferCashDesksReducer';
import { ViewDataTransferCashDesks } from 'components/containers/dashboard/dataTransferCashDesks/ViewComponent';
import { useInputChange } from 'hooks/useInputChange';
import {
    typePaginationDashboardObject
} from 'components/containers/dashboard/DashboardContentTable/PaginationDashboard/PaginationDashboard';


// Type
export type typeTransferCashDesks = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export type typeDataTransferCashDesksRowActions = { title: JSX.Element, action: (id: string) => void }[]


// Component
export const DataTransferCashDesks: React.FC<typeTransferCashDesks> = ({ variant, setSidebarOpen }) => {

    const dispatch = useDispatch()

    // DateFilter
    const [isActiveFilters, setIsActiveFilters] = useState(false)
    const [ openFilterBar, setOpenFilterBar ] = useState(false)
    const filters = useSelector((state: { dTransferCashDesks: IdTransferCashDesksState }) => state.dTransferCashDesks.filters)

    // Pagination
    const pagination: typePaginationDashboardObject = {
        paginationObject: useSelector((state: { dTransferCashDesks: IdTransferCashDesksState }) => state.dTransferCashDesks.pagination),
        onGoToPage: (id) => dispatch(dTransferCashDesksSetPageNumberAC(id)),
        onSelectItems: (itemsPerPage) => dispatch(dTransferCashDesksSetItemsForPageAC(itemsPerPage))

    }


    // Did mount & Did unmount
    useEffect(() => {

        return () => {
            dispatch(dTransferCashDesksClearFiltersAC())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        dispatch(dTransferCashDesksSetDataSagaAC(filters, {
            page: pagination.paginationObject.pageNumber,
            size: pagination.paginationObject.itemsPerPage!
        }))
        // eslint-disable-next-line
    }, [ filters, pagination.paginationObject.pageNumber, pagination.paginationObject.itemsPerPage ])

    // Search panel
    const searchUserName = useSelector((state: { dTransferCashDesks: IdTransferCashDesksState }) => state.dTransferCashDesks.filters?.posSnNumber)

    const {
        value: searchValue,
        setValue: setSearchValue,
        changeValueHandler: onChangeSearchValue
    } = useInputChange(searchUserName || '')

    const onClearSearch = () => {
        dispatch(dTransferCashDesksSetFiltersAC({
                                                    posSnNumber: null
                                                }))
        setSearchValue('')
    }
    const onEnterSearch = () => {
        const filters: typeTransferCashDesksFilters = {
            posSnNumber: searchValue.trim()
        }
        dispatch(dTransferCashDesksSetFiltersAC(filters))

    }

    // Current item
    const currentItem = useSelector((state: { dTransferCashDesks: IdTransferCashDesksState }) => state.dTransferCashDesks.detailItem)

    // Popup details
    const [ openPopupDetails, setOpenPopupDetails ] = useState(false)

    // Popup add
    const [ openPopupAdd, setOpenPopupAdd ] = useState(false)

    //
    // // Delete dialog
    // const [openCancelledDialog, setOpenCancelledDialog] = useState(false)
    //
    // // Delete dialog actions
    // const onCancelledCancelHandler = () => {
    //     setOpenCancelledDialog(false)
    // }
    // const onCancelledConfirmHandler = async  () => {
    //     const dataEditObject: IdTransferCashDesksStateDataItem = {
    //         status: TransferCashDesksTATUS.CANCELLED,
    //         id: currentItem!.id,
    //
    //     }
    //     await dispatch(dTransferCashDesksEditItemSagaAC(dataEditObject, token, refreshToken, filters))
    //
    //     setOpenCancelledDialog(false)
    // }

    //
    // // Make table item actions
    // const rowsActions = [
    //
    //     {
    //         id: 'changeStatus',
    //         title: <Trans>Cancel ticket</Trans>,
    //         action: (id: string) => {
    //             dispatch(dTransferCashDesksSetDetailItemAC(id))
    //             setOpenCancelledDialog(true)
    //         }
    //
    //     }
    // ]

    return (
        <ViewDataTransferCashDesks

            variant={ variant }
            setSidebarOpen={ setSidebarOpen }

            openFilterBar={ openFilterBar }
            setOpenFilterBar={ setOpenFilterBar }

            openPopupDetails={ openPopupDetails }
            setOpenPopupDetails={ setOpenPopupDetails }

            openPopupAdd={ openPopupAdd }
            setOpenPopupAdd={ setOpenPopupAdd }


            searchValue={ searchValue }
            onChangeSearchValue={ onChangeSearchValue }
            onEnterSearch={ onEnterSearch }
            onClearSearch={ onClearSearch }

            // rowsActions={ rowsActions }

            currentItem={ currentItem }

            isActiveFilters={isActiveFilters}
            setIsActiveFilters={setIsActiveFilters}
        />

    )
}
